import city from './city';

export default {
  city,
};
